import type { IconSvgObject } from './types';

const AlignVerticalJustifyEndIcon: IconSvgObject = [
  ["path", { d: "M16 12L8 12C6.89543 12 6 12.8954 6 14L6 15C6 16.1046 6.89543 17 8 17H16C17.1046 17 18 16.1046 18 15V14C18 12.8954 17.1046 12 16 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 3L10 3C8.89543 3 8 3.89543 8 5L8 6C8 7.10457 8.89543 8 10 8L14 8C15.1046 8 16 7.10457 16 6V5C16 3.89543 15.1046 3 14 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 21L3 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignVerticalJustifyEndIcon;
